import { iGameSaved, iGameTemplate, iHouseState } from "../context/interfaces";
interface response {
  houseStates: iHouseState[][],
  maxScore: number,
}

export default function initializeHousesStates(template: iGameTemplate, saved: iGameSaved): response {
  let houseStates: iHouseState[][] = [];
  let maxScore = 0;
  //initialize the house state based on the template
  for (let i = 0; i < template.matrix.length; i++) {
    houseStates[i] = [];
    for (let j = 0; j < template.matrix[i].length; j++) {
      if (template.matrix[i][j].palavra_horizontal !== -1 || template.matrix[i][j].palavra_vertical !== -1) {
        maxScore++
      }
      //check if the currrent house was sccored
      let scored = false;
      if (saved.cache.matrix[i][j]?.letra === template.matrix[i][j]?.letra.toUpperCase()) {
        scored = true;
      }
      houseStates[i][j] = {
        isSubFocused: false,
        isCorrect: '',
        isFocused: false,
        scored: scored,
        isHighlight: template.matrix[i][j].destaque,
        palavraHorizontal: template.matrix[i][j].palavra_horizontal,
        palavraVertical: template.matrix[i][j].palavra_vertical,
      };
    }
  }

  return { houseStates, maxScore };
}
